import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { RouterPath } from "../../assets/dictionary/RouterPath";

export default function AuthEntryRedirect({ tab }) {
  const location = useLocation();
  const params = new URLSearchParams(location.search || "");

  if (tab && !params.get("tab")) {
    params.set("tab", tab);
  }

  const search = params.toString();
  const to = `${RouterPath.AUTH}${search ? `?${search}` : ""}${location.hash || ""}`;

  return <Navigate to={to} replace state={location.state} />;
}

